import { ROUTE_REBUILD_SOURCE_TRANSLATION_KEY_MAP } from "../../constants/rebuild-route.const";
import type {
  DirectionsServiceEnum,
  RouteRebuildSourceEnum,
} from "../../enums";

export const formatRouteRebuildSuccessToast = ({
  baseMessage,
  provider,
  routeRebuildSource,
  t,
}: {
  baseMessage: string;
  provider?: DirectionsServiceEnum | string | null;
  routeRebuildSource?: RouteRebuildSourceEnum;
  t: (key: string) => string;
}): string => {
  const details: string[] = [];

  if (provider) {
    details.push(String(provider));
  }

  if (routeRebuildSource) {
    details.push(
      t(ROUTE_REBUILD_SOURCE_TRANSLATION_KEY_MAP[routeRebuildSource]),
    );
  }

  return details.length
    ? `${baseMessage} (${details.join(", ")})`
    : baseMessage;
};
